/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{--header-height:109.35px;display:block;height:calc(100vh - var(--header-height))}"];
export { styles as styles };
//# sourceMappingURL=notifications-list-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/notifications-list/notifications-list-page/notifications-list-page.component.scss.shim.ngstyle.js
// module id = 1751
// module chunks = 27 28 29